export default "__VITE_ASSET__sNiiX5FT__"